import { render } from "./ElementCreateSelection.vue?vue&type=template&id=15b60d90&scoped=true&ts=true"
import script from "./ElementCreateSelection.vue?vue&type=script&lang=ts"
export * from "./ElementCreateSelection.vue?vue&type=script&lang=ts"

import "./ElementCreateSelection.vue?vue&type=style&index=0&id=15b60d90&lang=scss&scoped=true"

import exportComponent from "D:\\zhangjc\\zhangjc_pro\\Edensoft.AIManage\\Edensoft.AIManageGit\\Edensoft.AIManage\\Edensoft.AIManage.PPTCopilot.PPTist.Apache-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15b60d90"]])

export default __exports__